// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1BnYr","label":"Radio_label__2heIW","checkMark":"Radio_checkMark__53Bxd","disabled":"Radio_disabled__Icjma"};